import * as React from 'react';
export var CleanerWaterSanitation = function CleanerWaterSanitation(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 552.1 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(0.000000, 0.045061)"
  }, React.createElement("path", {
    fill: "#00A6D6",
    d: "M404.4,290.6l7.5-45.8H165.5l10.4,53.2c17.9,0.1,32.7-5.3,48.6-11\n\t\t\t\tc23.9-8.6,44.2,5.6,65.8,12.3c34.4,10.8,56.6,6,89.2-7.3C388.2,288.6,397.3,287.5,404.4,290.6z M320.9,448.7\n\t\t\t\tc19.7-19.7,12.7-44.3,5.8-56.9c-4.2-7.9-34.6-53.5-37.1-57.4v-0.3l-0.1,0.1c-0.1-0.1-0.1-0.1-0.1-0.1v0.3\n\t\t\t\tc-2.6,3.9-32.9,49.4-37.1,57.4c-6.9,12.7-13.9,37.2,5.8,56.9c0,0,11.9,12.3,31.4,11C308.9,461,320.9,448.7,320.9,448.7z\n\t\t\t\t M422.6,234.3c0.6,0.7,0.8,1.6,0.7,2.5l-41.4,267.8c-0.2,1.5-1.5,2.6-3,2.6h-55.2l-3.7,43.5h22.8L289.5,604l-53.1-53.2h22.8\n\t\t\t\tl-3.7-43.6h-54.3c-1.5,0-2.8-1.1-3-2.6L154,236.8c-0.1-0.8,0.1-1.8,0.7-2.5s1.5-1,2.4-1h263.2C421.2,233.3,422,233.6,422.6,234.3\n\t\t\t\tz"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M24.6,88.2C25,80,28.5,74.8,36.2,74.8c8.4,0,11.6,5.2,11.6,14.7V115\n\t\t\t\tc0,9.3-3.4,14.7-11.9,14.7c-8.2,0-11.4-5.6-11.4-14.7V88.2H24.6z M36,149.8c26.1,0,36.2-14.3,36.2-37V91.3\n\t\t\t\tc0-24-9.5-36.1-27.2-36.1c-10.4,0-16.6,4.8-20.3,11.9h-0.2V35.6c0-8.9,2.8-15.1,11.6-15.1s11.4,5.2,11.4,14.3v9.7h22.4v-7.8\n\t\t\t\tC69.9,15.1,62.8,0,35.6,0C9.7,0,0,16.6,0,39.5v71.3C0.2,133.4,10.1,149.8,36,149.8z"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M136.8,48.5V18.9c0-9.6,4.5-16.5,15.3-16.5c11.4,0,14.5,6.3,14.5,15.4V25h-9.4v-8\n\t\t\t\tc0-3.8-1.3-6-5-6c-3.7,0-5.2,2.6-5.2,6.3v32.9c0,3.7,1.5,6.3,5.2,6.3c3.7,0,5-2.3,5-6V39.2h9.4v10.6c0,8.8-3.6,15.3-14.5,15.3\n\t\t\t\tC141.3,65.1,136.8,58,136.8,48.5"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "172.2,3.1 182.5,3.1 182.5,55.9 194.7,55.9 194.7,64.3 172.2,64.3"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "199.4,3.1 224,3.1 224,11.5 209.7,11.5 209.7,29 219.9,29 219.9,37.3 209.7,37.3 \n\t\t\t\t209.7,55.9 224,55.9 224,64.3 199.4,64.3"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M240.7,44.9h8.2l-4.1-24.6h-0.1L240.7,44.9z M227.8,64.3l11.5-61.2H251l11.6,61.2h-10.5\n\t\t\t\tl-1.9-11.2h-10.9l-1.8,11.2H227.8z"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "275.6,25.9 275.6,64.3 267,64.3 267,3.1 277.1,3.1 288.2,38.2 288.2,3.1 296.7,3.1 \n\t\t\t\t296.7,64.3 287.7,64.3"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "334.2,26.5 328.5,64.3 318.8,64.3 310.6,3.1 320.5,3.1 325.3,41.9 325.4,41.9 \n\t\t\t\t330.5,3.1 338.9,3.1 344.6,41.9 344.7,41.9 349.4,3.1 358,3.1 350.1,64.3 340.4,64.3 334.3,26.5"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M370.1,44.9h8.2l-4.1-24.6h-0.1L370.1,44.9z M357.2,64.3l11.5-61.2h11.7L392,64.3h-10.5\n\t\t\t\tl-1.9-11.2h-10.9L367,64.3H357.2z"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "390.7,3.1 418,3.1 418,11.5 409.5,11.5 409.5,64.3 399.2,64.3 399.2,11.5 \n\t\t\t\t390.7,11.5"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "422.8,3.1 447.3,3.1 447.3,11.5 433,11.5 433,29 443.2,29 443.2,37.3 433,37.3 \n\t\t\t\t433,55.9 447.3,55.9 447.3,64.3 422.8,64.3"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M463.1,11.5v19.1h3.4c3.5,0,5-1.8,5-5.1v-9c0-3.3-1.5-5-5-5H463.1z M463.1,36.2v28.1h-10.3\n\t\t\t\tV3.1h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L463.1,36.2z"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M148,130.7h8.2l-4.1-24.6H152L148,130.7z M135.1,150.1l11.5-61.2h11.7l11.6,61.2h-10.5\n\t\t\t\tl-1.9-11.2h-10.9l-1.8,11.2H135.1z"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "182.9,111.6 182.9,150.1 174.3,150.1 174.3,88.9 184.4,88.9 195.5,124 195.5,88.9 \n\t\t\t\t204,88.9 204,150.1 195,150.1"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M224.5,141.7c4.2,0,5.9-2.5,5.9-6.2v-32.1c0-3.6-1.6-6.1-5.9-6.1h-4.3v44.4H224.5z\n\t\t\t\t M240.6,105.3v28.4c0,9.4-3.9,16.4-14.9,16.4h-15.9V88.9h15.9C236.8,88.9,240.6,95.8,240.6,105.3z"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M255.4,136.9v-8.2h9.6v8.4c0,3.4,1.5,5.4,5.1,5.4c3.2,0,4.7-2.2,4.7-5.4v-2.3\n\t\t\t\tc0-3.5-1.4-5.7-4.6-8.7l-6-6.1c-5.9-5.8-8.6-9.3-8.6-16.3v-2.1c0-7.6,4.4-13.5,14.4-13.5c10.3,0,14.3,5.1,14.3,13.9v5h-9.4v-5.3\n\t\t\t\tc0-3.5-1.6-5.2-4.9-5.2c-2.9,0-4.9,1.6-4.9,5.1v1.3c0,3.4,1.9,5.4,4.9,8.3l6.6,6.5c5.6,5.7,8.3,9.1,8.3,15.9v3\n\t\t\t\tc0,8.4-4.5,14.4-15,14.4C259.5,150.8,255.4,145,255.4,136.9"
  }), React.createElement("path", {
    fill: "#00A6D6",
    d: "M300.7,130.7h8.2l-4.1-24.6h-0.1L300.7,130.7z M287.8,150.1l11.5-61.2H311l11.6,61.2h-10.5\n\t\t\t\tl-1.9-11.2h-10.9l-1.8,11.2H287.8z"
  }), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "335.6,111.6 335.6,150.1 326.9,150.1 326.9,88.9 337,88.9 348.1,124 348.1,88.9 \n\t\t\t\t356.7,88.9 356.7,150.1 347.7,150.1"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "362.5,150.1 372.8,150.1 372.8,88.9 362.5,88.9"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "377.6,88.9 404.9,88.9 404.9,97.3 396.4,97.3 396.4,150.1 386.1,150.1 386.1,97.3 \n\t\t\t\t\t377.6,97.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#00A6D6",
    d: "M416.5,130.7h8.2l-4.1-24.6h-0.1L416.5,130.7z M403.6,150.1l11.5-61.2h11.7l11.6,61.2\n\t\t\t\t\th-10.5l-1.9-11.2h-10.9l-1.8,11.2H403.6z"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "437,88.9 464.3,88.9 464.3,97.3 455.9,97.3 455.9,150.1 445.5,150.1 445.5,97.3 \n\t\t\t\t\t437,97.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "469.1,150.1 479.4,150.1 479.4,88.9 469.1,88.9"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("path", {
    fill: "#00A6D6",
    d: "M506.2,135.9V103c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9\n\t\t\t\t\tc0,3.7,1.6,6.3,5.2,6.3C504.6,142.2,506.2,139.6,506.2,135.9 M485.3,134.3v-29.6c0-9.6,4.7-16.5,15.5-16.5\n\t\t\t\t\tc10.9,0,15.6,7,15.6,16.5v29.6c0,9.5-4.7,16.5-15.6,16.5C490,150.8,485.3,143.8,485.3,134.3"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#00A6D6",
    points: "531,111.6 531,150.1 522.3,150.1 522.3,88.9 532.4,88.9 543.5,124 543.5,88.9 \n\t\t\t\t\t552.1,88.9 552.1,150.1 543.1,150.1"
  }))))));
};